module.exports = __webpack_public_path__ + "static/media/icon-check.9968e3d5.svg";